import React from "react";
import { Box } from "@mui/material";
import PlatformIcon from "./PlatformIcon";

/**
 * Section that displays cross-platform support information
 */
const CrossPlatformSection = () => {
  return (
    <div
      id="cross-platform-section"
      className="section overflow-hidden"
      style={{
        backgroundColor: "#ffffff",
        padding: "40px 20px",
      }}
    >
      <div
        style={{
          backgroundImage: "url('./secbg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          borderRadius: "24px",
          boxShadow:
            "inset 0 4px 20px rgba(0, 0, 0, 0.3), inset 0 -4px 20px rgba(0, 0, 0, 0.2)",
          overflow: "hidden",
          margin: "0 auto",
          maxWidth: "1200px",
        }}
      >
        <div
          className="container"
          style={{ paddingTop: "60px", paddingBottom: "60px" }}
        >
          {/* Glassmorphic neumorphic container */}
          <div className="glass-neumorphic-container">
            <div className="section-center-text">
              <div className="section-title">
                <div>
                  <h2 className="title medium" style={{ color: "#ffffff" }}>
                    <strong>Cross-Platform Support</strong>
                  </h2>
                </div>
              </div>
              <div className="section-paragraph">
                <div>
                  <p style={{ color: "#ffffff" }}>
                    Seamlessly access your tools and workspaces
                    <br />
                    on any device.
                  </p>
                </div>
              </div>
            </div>
            <div
              className="w-layout-grid ease-features-grid"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: {
                    xs: 4,
                    sm: 8,
                  },
                  width: "100%",
                  mt: 1,
                }}
              >
                <div>
                  <PlatformIcon icon="./images/apple.png" label="Mac" />
                </div>
                <div>
                  <PlatformIcon icon="./images/window.png" label="Windows" />
                </div>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrossPlatformSection;
